import styled, { css } from 'styled-components'

import { InputWrapper, LabelText } from 'src/comps/Atom/Inputs/Input/styles'

interface SuggesterFullWrapperProps {
  hasFocus: boolean
  hasError: boolean
}

export const SuggesterFullWrapper = styled.div<SuggesterFullWrapperProps>`
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 6px;
  border-radius: 32px;

  ${InputWrapper} {
    width: calc(100% - 40px);
    padding-inline-start: 12px;
    border: none;
    background: none;
    inset-inline-end: 8px;

    & svg {
      margin-block: 0;
      margin-inline: 0;
    }

    ${LabelText} {
      display: none;
    }

    &:hover {
      border: none;
    }

    input {
      padding-block: 0;
      padding-inline: 0;
      padding-inline-start: 5px;
      text-overflow: ellipsis;

      @keyframes blink_input_opacity_to_prevent_scrolling_when_focus {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      input:focus {
        animation: blink_input_opacity_to_prevent_scrolling_when_focus 0.01s;
      }

      svg {
        margin-block: 0;
        margin-inline: 8px 0;
      }
    }
  }

  ${({ theme, hasFocus }) =>
    hasFocus &&
    css`
      border: none;
      border-block-end: 2px solid ${theme.colors.grey5};
      border-radius: 0;
      padding-block: 5px;
      padding-inline: 8px;
    `}

  ${({ hasFocus, hasError }) =>
    !hasFocus &&
    !hasError &&
    css`
      ${InputWrapper} {
        width: 100%;
        border-radius: 50px;
        inset-inline-end: 0;
        & label {
          width: calc(100% - 60px);
        }

        &:hover {
          background: var(--color--neutral--300);
        }
      }
    `}

  ${({ hasError }) =>
    hasError &&
    css`
      color: var(--color--semantic--error--500);
      background: var(--color--semantic--error--100);
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;

      :hover {
        background: var(--color--semantic--error--100);
      }

      & input::placeholder {
        color: var(--color--semantic--error--500);
      }

      & svg {
        fill: var(--color--semantic--error--500);
      }
    `}
`
